






































































import { PropType } from 'vue';
import { computed, defineComponent, toRefs, ref } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData, BrandSafetyType, CreateMode } from '@tt4b/ttam-enums';
import { StateEnum, useAdgroupMode, useStore } from '@tt4b/ttam-hooks';

import EditDialog from './edit-dialog/index.vue';
import UnavaliableTip from './unavaliable-tip/index.vue';
import {
  generateInventoryFilterOptions,
  useBrandSafetyAvailableCountries,
  useInventoryFilterDisabled,
  autoUpgradeToFullTip,
} from './hooks';

const name = 'ttam-inventory-filter-compose';

export default defineComponent({
  name,
  components: {
    EditDialog,
    UnavaliableTip,
    // InventoryFilter,
    // ViLearnMore,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    originAdgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    isBsEditable: {
      type: Boolean,
      default: false,
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, originAdgroupData, campaignData, createMode, isBsEditable } = toRefs(props);
    const isFilterEditDialogVisible = ref(false);
    useBrandSafetyAvailableCountries(adgroupData.value);
    const { getStore } = useStore();

    const { inventoryFilterLimitedTip, isInventoryFilterUnavailable, isSupportExpandedTire } =
      useInventoryFilterDisabled({
        campaignFormData: campaignData,
        adgroupFormData: adgroupData,
      });

    const { isEdit } = useAdgroupMode({
      createMode,
    });
    const { data: brandSafetyCenterInfo } = getStore(StateEnum.brandSafetyCenterInfo, undefined, false, false);

    // 编辑adgroup，inventory-filter只允许从“宽限制”(full/expanded)改到“窄限制”(standard/limited)，不可反过来
    const isExpandedFullDisabled = computed(
      () =>
        isEdit.value &&
        [BrandSafetyType.STANDARD_INVENTORY, BrandSafetyType.SELCTED_INVENTORY].includes(
          originAdgroupData.value.brandSafety,
        ),
    );
    const allInventoryFilterOptions = computed(() =>
      generateInventoryFilterOptions({
        isSupportExpandedTier: isSupportExpandedTire.value,
        bscInfo: brandSafetyCenterInfo.value,
        isExpandedFullDisabled: isExpandedFullDisabled.value,
      }),
    );

    const inventoryFilterOptions = computed(() => allInventoryFilterOptions.value.filter(item => !item.hide));

    const selectedOption = computed(
      () =>
        allInventoryFilterOptions.value.find(({ value }) => value === adgroupData.value.brandSafety) ||
        // 处理存量数据的回显
        allInventoryFilterOptions.value.find(({ value }) => value === BrandSafetyType.UN_SAFE),
    );

    const editBtnDisabledTip = computed(() => {
      if (isEdit.value) {
        return '';
      }
      return inventoryFilterLimitedTip.value;
    });

    const isSettingInventory = computed(
      () => isEdit.value && adgroupData.value.brandSafety && adgroupData.value.brandSafety !== BrandSafetyType.UN_SAFE,
    );

    const isEditBtnDisabled = computed(() =>
      Boolean(editBtnDisabledTip.value || (isEdit.value && !isBsEditable.value)),
    );

    const handleInventoryFilterEdit = () => {
      isFilterEditDialogVisible.value = true;
    };

    const onChanged = (val: BrandSafetyType) => {
      isFilterEditDialogVisible.value = false;
      emit('changed', val);
    };

    return {
      name,
      inventoryFilterOptions,
      selectedOption,
      isEditBtnDisabled,
      autoUpgradeToFullTip,
      isFilterEditDialogVisible,
      editBtnDisabledTip,
      isInventoryFilterUnavailable,
      isSettingInventory,
      inventoryFilterLimitedTip,
      isSupportExpandedTire,
      handleInventoryFilterEdit,
      onChanged,
    };
  },
});
